import React from "react";
import { useParams } from "react-router-dom";
import { ProjectList } from "../../helpers/ProjectList";
import "../../styles/ProjectDisplay.css";
import "../../styles/projects/Retriever.css";
import Slider from "../../components/Slider";
import { retrieverImg } from "../../helpers/SliderImages";

function FirstApp() {
  const { id } = useParams();
  const project = ProjectList[2];
  return (
    <div className="project">
      <div className="project-title">
        <h1 style={{ color: "#3e497a" }}> {project.name}</h1>
      </div>
      <Slider mediaArray={retrieverImg} />
      <div className="projectContent">
        <p>
          <b>Skills:</b> {project.skills}
        </p>
        <p>
          <b>Overview:</b> {project.overview}
        </p>
      </div>
    </div>
  );
}

export default FirstApp;
